export default __webpack_public_path__ + "static/media/work_1.f3e643cc.jpg";